/* tslint:disable */
/* eslint-disable */
/**
 * Kontor API
 * OpenAPI specification for Kontor application framework
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * All object attributes
 * @export
 * @interface EventLocationAttributes
 */
export interface EventLocationAttributes {
    /**
     * Location name
     * @type {string}
     * @memberof EventLocationAttributes
     */
    name: string;
    /**
     * Postal address
     * @type {string}
     * @memberof EventLocationAttributes
     */
    address: string;
    /**
     * ZIP code
     * @type {string}
     * @memberof EventLocationAttributes
     */
    zip: string;
    /**
     * City
     * @type {string}
     * @memberof EventLocationAttributes
     */
    city: string;
    /**
     * Country
     * @type {string}
     * @memberof EventLocationAttributes
     */
    country: string;
    /**
     * Phone number
     * @type {string}
     * @memberof EventLocationAttributes
     */
    phone?: string;
    /**
     * Email address
     * @type {string}
     * @memberof EventLocationAttributes
     */
    email?: string;
    /**
     * Website URL
     * @type {string}
     * @memberof EventLocationAttributes
     */
    url?: string;
}

export function EventLocationAttributesFromJSON(json: any): EventLocationAttributes {
    return EventLocationAttributesFromJSONTyped(json, false);
}

export function EventLocationAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventLocationAttributes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'zip': json['zip'],
        'city': json['city'],
        'country': json['country'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function EventLocationAttributesToJSON(value?: EventLocationAttributes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'address': value.address,
        'zip': value.zip,
        'city': value.city,
        'country': value.country,
        'phone': value.phone,
        'email': value.email,
        'url': value.url,
    };
}

